module.exports = __webpack_public_path__ + "img/RUB.65cc3a45.svg";